import * as Yup from "yup";

export const firstNationStatus = () => {
  return Yup.object().shape({
    isIndigenous: Yup.string()
      .oneOf(["Y", "N"], "Please select yes or no")
      .required("Please indicate your Indigenous status"),
    band: Yup.string().when("isIndigenous", {
      is: "Y",
      then: () =>
        Yup.string()
          .matches(/^\d{3}$/, "Band number must be 3 digits")
          .required("Band number is required"),
      otherwise: () => Yup.string().nullable(),
    }),
    family: Yup.string().when("isIndigenous", {
      is: "Y",
      then: () =>
        Yup.string()
          .matches(/^\d{5}$/, "Family number must be 5 digits")
          .required("Family number is required"),
      otherwise: () => Yup.string().nullable(),
    }),
    position: Yup.string().when("isIndigenous", {
      is: "Y",
      then: () =>
        Yup.string()
          .matches(/^\d{2}$/, "Position must be 2 digits")
          .required("Position is required"),
      otherwise: () => Yup.string().nullable(),
    }),
    FNIHB: Yup.string().when("isIndigenous", {
      is: "Y",
      then: () =>
        Yup.string()
          .matches(/^\d{8}$/, "FNIHB number must be 8 digits")
          .required("FNIHB number is required"),
      otherwise: () => Yup.string().nullable(),
    }),
    livesOnReserve: Yup.string().when("isIndigenous", {
      is: "Y",
      then: () =>
        Yup.string()
          .oneOf(["Y", "N"], "Please select yes or no")
          .required("Please indicate if you live on reserve"),
      otherwise: () => Yup.string().nullable(),
    }),
  });
};
